import React from 'react';

import {
  Breakpoints,
  TextAlignment,
  TextTag,
} from '@volkswagen-onehub/components-core';
import {
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextWeight,
} from '@vw-marketing/us-components';

import { PageContentTitle, PageMainContainer, StyledContentDescription } from './styles';
import { useMyVwContext } from '../../hooks/use-my-vw-context';
import GoBackComponent from '../go-back';

interface PageContainerProps {
  children: React.ReactNode;
  descriptionKey?: string;
  labelKey?: string;
  textAppearance?: TextAppearance;
  upperBreakpoint?: Breakpoints;
}

const PageContainer = ({
  children,
  descriptionKey,
  labelKey,
  textAppearance = TextAppearance.bigcopy200,
  upperBreakpoint = Breakpoints.b1280,
}: PageContainerProps) => {
  const { translationHandler } = useMyVwContext();
  return (
    <PageMainContainer>
      <GoBackComponent />
      <PageContentTitle>
        <TextCustom
          appearance={textAppearance}
          tag={TextTag.p}
          style={{
            [Breakpoints.default]: {
              color: TextColor.primary,
              fontWeight: TextWeight.light,
              fontSize: TextSize.TextSize32,
              lineHeight: TextLineHeight.TextLineHeight36,
              textAlign: TextAlignment.left,
            },
            [upperBreakpoint]: {
              fontSize: TextSize.TextSize48,
              lineHeight: TextLineHeight.TextLineHeight56,
            },
          }}
        >
          {labelKey && translationHandler(labelKey)}
        </TextCustom>
      </PageContentTitle>
      {descriptionKey && (
        <StyledContentDescription>
          <TextCustom
            appearance={TextAppearance.copy100}
            tag={TextTag.p}
            style={{
              [Breakpoints.default]: {
                color: TextColor.primary,
                fontWeight: TextWeight.regular,
                fontSize: TextSize.TextSize14,
                lineHeight: TextLineHeight.TextLineHeight24,
                textAlign: TextAlignment.left,
              },
              [Breakpoints.b960]: {
                fontSize: TextSize.TextSize16,
              },
            }}
          >
            {translationHandler(descriptionKey)}
          </TextCustom>
        </StyledContentDescription>
      )}
      {children}
    </PageMainContainer>
  );
};

export default PageContainer;
